import React, {FC} from "react";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Button, Divider, Popconfirm, Tooltip} from "antd";
import {DeleteTwoTone, EditOutlined, PlusOutlined} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import SupplierModel from "../../models/dto/supplier-model";
import Drawer from "../../components/drawer/drawer";
import SupplierForm from "../../forms/supplier-form/supplier-form";
import useSafeState from "../../utils/safe-state";
import {useAxios} from "../../utils/hooks";
import {openNotification} from "../../utils/openNotification";
import ButtonWithIcon from "../../components/buttons/button-with-icon";

const SuppliersScreen: FC = () => {
    const drawer = Drawer({
        title: <Trans>Supplier</Trans>,
        children: <SupplierForm onSuccess={() => setTrigger(!trigger)} />,
        customClose: () => setTrigger(!trigger)
    });

    const [trigger, setTrigger] = useSafeState(false);
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");

    const handleDelete = (record: any) => {
        if (axiosInstance.current == null) return;
        axiosInstance.current
            .delete(`/resource/suppliers/${encodeURIComponent(record.id)}`)
            .then(() => {
                openNotification('customSuccess', 'Supplier deleted successfully');
                setTrigger(!trigger);
            })
            .catch((error: any) => {
                const message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Delete failed';
                openNotification('error', message);
            });
    };

    const action = (record: any) => (
        <>
            <Tooltip title={<Trans>Edit</Trans>}>
                <EditOutlined
                    className="ActionButtons"
                    style={{color: "#40a9ff"}}
                    onClick={() => drawer.open('Edit', record)}
                />
            </Tooltip>
            <Tooltip title={<Trans>Remove</Trans>}>
                <Popconfirm
                    title={<Trans>Are you sure want to delete record?</Trans>}
                    onConfirm={() => handleDelete(record)}
                    okText={<Trans>Yes</Trans>}
                    cancelText={<Trans>No</Trans>}>
                    <DeleteTwoTone className={'ActionButtons'} twoToneColor={'red'}/>
                </Popconfirm>
            </Tooltip>
        </>
    );

    const actions = {
        width: 150,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const header = (
        <>
            <Button type={'primary'} onClick={() => drawer.open('Add new')} style={{ float: 'left' }}>
                <ButtonWithIcon icon={<PlusOutlined />} text={<Trans>Új hozzáadása</Trans>} />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
        </>
    );

    return (
        <>
            <Breadcrumb style={{marginBottom: 10}}>
                <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'Suppliers'}></Trans></Breadcrumb.Item>
            </Breadcrumb>
            <DtoTable
                tableHeader={header}
                model={SupplierModel}
                action={actions}
                trigger={trigger}
                allowRefreshButton={true}
                pageSize={50}
                scroll={{x: 900, y: "65vh"}}
            />
            {drawer.component}
        </>
    );
};

export default SuppliersScreen;
